import GLTFLoader from 'three-gltf-loader'

const gltfLoader = new GLTFLoader()

export const loadGltf = (
  url = '',
  onProgress = xhr => console.log((xhr.loaded / xhr.total * 100) + '% loaded')
) => {
  return new Promise((resolve, reject) => {
    gltfLoader.load(url, gltf => {
      resolve(gltf)
    }, xhr => {
      onProgress(xhr)
    }, err => {
      reject(err)
    })
  })
}


// WEBPACK FOOTER //
// ./src/utils/loader.js